(function() {
  'use strict';

  // Counter animation function
  function animateCounter(element, target, duration, suffix) {
    const startValue = 0;
    const increment = target / (duration / 16); // 60fps
    let currentValue = startValue;
    
    element.classList.add('is-animating');
    
    const timer = setInterval(function() {
      currentValue += increment;
      
      if (currentValue >= target) {
        currentValue = target;
        clearInterval(timer);
        element.classList.remove('is-animating');
      }
      
      // Format the number (handle decimals for smooth animation)
      const displayValue = Math.floor(currentValue);
      element.textContent = displayValue.toLocaleString() + suffix;
    }, 16); // ~60fps
  }

  // Easing function for smoother animation
  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  // Enhanced counter animation with easing
  function animateCounterWithEasing(element, target, duration, suffix) {
    const startTime = Date.now();
    
    element.classList.add('is-animating');
    
    function update() {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = easeOutCubic(progress);
      
      const currentValue = Math.floor(target * easedProgress);
      element.textContent = currentValue.toLocaleString() + suffix;
      
      if (progress < 1) {
        requestAnimationFrame(update);
      } else {
        element.classList.remove('is-animating');
      }
    }
    
    requestAnimationFrame(update);
  }

  // Initialize section
  function initStatsBanner(section) {
    const statCards = Array.from(section.querySelectorAll('[data-stat-card]'));
    const numberElements = Array.from(section.querySelectorAll('.stats-banner__number[data-target]'));
    
    if (numberElements.length === 0) return;
    
    let hasAnimated = false;
    
    // Intersection Observer for triggering animations
    const observerOptions = {
      root: null,
      rootMargin: '0px 0px -20% 0px', // Trigger when 80% of the section is visible
      threshold: 0.3
    };
    
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting && !hasAnimated) {
          hasAnimated = true;
          animateAllCounters();
        }
      });
    }, observerOptions);
    
    // Observe the section
    observer.observe(section);
    
    // Function to animate all counters simultaneously
    function animateAllCounters() {
      // Find the longest duration to sync all animations
      const maxDuration = Math.max.apply(Math, numberElements.map(function(el) {
        return parseInt(el.getAttribute('data-duration') || '2000');
      }));
      
      // Start all animations with the same duration for synchronization
      numberElements.forEach(function(element, index) {
        const target = parseInt(element.getAttribute('data-target') || '0');
        const suffix = element.getAttribute('data-suffix') || '';
        
        // Add a small delay for staggered effect
        setTimeout(function() {
          animateCounterWithEasing(element, target, maxDuration, suffix);
        }, index * 100); // 100ms delay between each counter
      });
    }
    
    // Handle reduced motion preference
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      // Skip animations for users who prefer reduced motion
      numberElements.forEach(function(element) {
        const target = parseInt(element.getAttribute('data-target') || '0');
        const suffix = element.getAttribute('data-suffix') || '';
        element.textContent = target.toLocaleString() + suffix;
      });
      return;
    }
    
    // Fallback for older browsers without Intersection Observer
    if (!window.IntersectionObserver) {
      // Simple scroll-based trigger
      let scrollListener = function() {
        if (hasAnimated) return;
        
        const sectionRect = section.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        // Trigger when section is 70% visible
        if (sectionRect.top <= windowHeight * 0.7 && sectionRect.bottom >= 0) {
          hasAnimated = true;
          animateAllCounters();
          window.removeEventListener('scroll', scrollListener);
        }
      };
      
      window.addEventListener('scroll', scrollListener, { passive: true });
      scrollListener(); // Check immediately
    }
  }
  
  // Initialize on DOM ready
  function initAllSections() {
    const sections = document.querySelectorAll('[id^="StatsBanner-"]');
    sections.forEach(initStatsBanner);
  }
  
  // Handle page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllSections);
  } else {
    initAllSections();
  }
  
  // Handle Shopify theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const section = event.target;
      if (section && section.id && section.id.indexOf('StatsBanner-') === 0) {
        // Small delay to ensure DOM is ready
        setTimeout(function() {
          initStatsBanner(section);
        }, 100);
      }
    });
    
    document.addEventListener('shopify:section:reorder', function() {
      setTimeout(initAllSections, 100);
    });
  }
  
  // Handle dynamic content loading (if applicable)
  if (window.MutationObserver) {
    const bodyObserver = new MutationObserver(function(mutations) {
      let shouldReinit = false;
      
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.id && node.id.indexOf('StatsBanner-') === 0) {
            shouldReinit = true;
          }
        });
      });
      
      if (shouldReinit) {
        setTimeout(initAllSections, 100);
      }
    });
    
    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  
  // Utility function for debugging (can be removed in production)
  window.debugStatsBanner = function() {
    const sections = document.querySelectorAll('[id^="StatsBanner-"]');
    console.log('Found', sections.length, 'stats banner sections');
    sections.forEach(function(section, index) {
      const numbers = section.querySelectorAll('.stats-banner__number[data-target]');
      console.log('Section', index + 1, 'has', numbers.length, 'counters');
    });
  };
  
})();
